module.exports = __webpack_public_path__ + "img/article-image-3.e226d53f.webp";